import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsBoolean, IsEnum, IsOptional, IsString, MaxLength } from 'class-validator';
import { CreatePersonaDto } from 'src/personas/dto/create-persona.dto';

export enum TipoTransportista {
  PROPIO = 'propio',
  TERCERO = 'tercero',
}

export class CreateTransportistaDto extends CreatePersonaDto {
  @ApiPropertyOptional({ enum: TipoTransportista, default: TipoTransportista.TERCERO })
  @IsEnum(TipoTransportista)
  @IsOptional()
  tipo_transportista?: TipoTransportista;

  @ApiPropertyOptional({ example: 'MOC-001234' })
  @IsString()
  @IsOptional()
  @MaxLength(50)
  nro_habilitacion_mopc?: string;

  @ApiPropertyOptional({ default: true })
  @IsBoolean()
  @IsOptional()
  activo?: boolean;
}
